import React from 'react'
import { Link, graphql } from 'gatsby'
import loadable from '@loadable/component'
import Layout from '../../components/Layout'
import Helmet from 'react-helmet'
import Img from "gatsby-image"
import { InlineWidget } from "react-calendly";

const FormMsg = loadable(() => import('../../components/FormMsg'));
const Typewriter = loadable(() => import('typewriter-effect'));
// const MapContainer = loadable(() => import('../../components/Map'));

export default class Index extends React.Component {

  componentDidMount(){

      var lazyBackgrounds = [].slice.call(
        document.querySelectorAll(".lazy-load")
      );

      if (
        "IntersectionObserver" in window &&
        "IntersectionObserverEntry" in window &&
        "intersectionRatio" in window.IntersectionObserverEntry.prototype
      ) {
        let lazyBackgroundObserver = new IntersectionObserver(function (
          entries,
          observer
        ) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              if(entry.target.id === 'calendly'){
                console.log('calendly')
              } else if (entry.target.id === 'mapp'){
                console.log('map')
              }
              lazyBackgroundObserver.unobserve(entry.target);

            }
          });
        });
        lazyBackgrounds.forEach(function (lazyBackground) {
          lazyBackgroundObserver.observe(lazyBackground);
        });
      }
    ;
    document.getElementById('lang-switch').href = 'https://e-multicontent.pl/kontakt/'
  }

  render() {
    const { data } = this.props
    return (
      <>
      <Helmet titleTemplate="Contact us - e-multicontent | Multilingual copywriting agency">
        <title>Contact us - e-multicontent | Multilingual copywriting agency</title>
        <meta name="description" content={'We will prepare graphic content, photos and videos for your online store. Check it out! ✔️'}/>
        <meta name='image' content={'https://e-multicontent.com/img/meta/kontakt-meta.jpg'} />
        <meta name='keywords' content={'copywriting, copywriters, marketing, copywriters agency, Wrocław, team of copywriters, work, business, content, content, translations, SEO, blog, texts, articles, graphics, video, websites, online stores, marketplace, e-commerce'} />
        <meta property="og:description" content={'We will prepare graphic content, photos and videos for your online store. Check it out! ✔️'}/>
        <meta property='og:title' content={'Contact us - e-multicontent.com | info@e-multicontent.com |  Wrocław'} />
        <meta property='og:image' content={'https://e-multicontent.com/img/meta/kontakt-meta.jpg'} />
        <meta property="og:url" content={'https://e-multicontent.com/contact-us/'}/>
        <link rel="alternate" href="https://e-multicontent.pl/kontakt/" hrefLang="pl-pl" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta property="twitter:domain" content="e-multicontent.com" />
        <meta property="twitter:url" content="https://e-multicontent.com/contact-us/" />
        <meta name="twitter:title" content="Contact us - e-multicontent.com | info@e-multicontent.com |  Wrocław" />
        <meta name="twitter:description" content="We will prepare graphic content, photos and videos for your online store. Check it out! ✔️" />
        <meta name="twitter:image" content="https://e-multicontent.com/img/apple-touch-icon.png" />

        <script type='application/ld+json'>
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [{
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": "https://e-multicontent.com/"
          },{
            "@type": "ListItem",
            "position": 2,
            "name": "Contact us",
            "item": "https://e-multicontent.com/contact-us/"
          }]
        })}
        </script>

      </Helmet>
      <Layout>
      <nav className="breadcrumbs-nav section">
          <Link className="inline-link" to="/">Home</Link>&nbsp;&gt;&nbsp;<span style={{fontWeight:'600'}}><b>Contact us</b></span>
      </nav>

      <div
        id="kontakt"
        className="full-width-image-container"
        style={{
          backgroundPosition: `75% center`,
          backgroundSize:'cover',
          transform: 'scale(1)',
          height:'509px',
          backgroundRepeat: 'no-repeat',
          paddingTop: '0px',
        }}
      >
        </div>
        <h1
          className="has-text-weight-bold is-size-1"
          style={{
            lineHeight: '1',
            padding: '0.35em',
            borderRadius:'10px',
            marginTop: '0%',
            display: 'block',
            position: 'absolute',
            left: '7%',
            top: '200px',
            color:'#36b3d2',
            textAlign: 'left',
            backgroundColor:'rgba(255,255,255,0.7)',
          }}
        >
        Contact us
        <br></br>
        </h1>
        <br></br>
        <h2
        className="mright"
        style={{
          color: 'rgb(23,19,43)',
          lineHeight: '1',
          padding: '0.35em',
          borderRadius:'10px',
          marginTop: '0%',
          display: 'block',
          position: 'absolute',
          left: '8%',
          maxWidth:'300px',
          top: '350px',
          textAlign: 'left',
          backgroundColor:'rgba(255,255,255,0.8)',}} >In our industry, contact with the client and face-to-face conversation are of key importance.</h2>



            <div style={{marginTop:'-50px'}}>



            <div style={{width:'100%'}}>
              <div style={{padding:'5%',paddingBottom:'2.5%',paddingTop:'2%',marginLeft:'2.5%'}}>
                <h3>Therefore, we are always at your disposal by phone and e-mail. <br />We can also meet directly at our office or at your company's headquarters, as well as organize an online meeting. <br /> Please make an appointment in advance.<br />
               <br />We will be happy to answer all your questions and prepare an individually tailored offer.</h3>
                 <br />
                <h3 className="is-size-2" style={{fontWeight:'800'}}>
                <Typewriter
                    onInit={(typewriter) => {
                      typewriter.typeString("<span style='color:#36b3d2'>Just give us</span> a call or e-mail us!")
                        .pauseFor(2500)
                        .deleteAll()
                        .start();
                    }}
                    options={{
                      autoStart: true,
                      loop: true,
                    }}
                  />
                </h3>
                <br />
                <p>You will find all the necessary contact details below:</p>
                <sub>The office is open from <b>8 am to 4 pm</b>, <b>Monday to Friday</b>.</sub>
                <br />
                <br />
              </div>

              <p className="ux" align="center" id="forms"><a className="btnoutline" href="#forms">⇩</a></p>
              <br />
              <br />
              <div style={{backgroundColor:'rgb(245, 245, 245)',padding:'5%'}}>

              <div className="columns" style={{margin:'auto'}}>

              <div className="column" style={{textAlign:'center'}}>
              <br />  <br />
              <div className="box lazy-load" id="calendly" style={{minWidth:'100%',height:'780px'}}>
              <InlineWidget url="https://calendly.com/a-filip" />
              </div>
              <br /><br />
              <Img fluid={data.file1.childImageSharp.fluid}
              imgStyle={{objectFit:'contain'}}
              alt="Contact us z e-multicontent - copywriting, tłumaczenia, seo, strony internetowe, e-commerce, marketplace"
              style={{
                padding: "0",
                borderRadius: "10px",width:'100%',minHeight:'244px',
                maxWidth:'550px', border:'3px solid #f5f5f5',margin:'auto',marginBottom:'25px',
                backgroundColor: 'white',objectFit:'contain',objectPosition:'top center'}} />
              </div>

              <div className="column" style={{position:'relative',textAlign:'center'}}>

              <h3 style={{fontSize:'1em',textAlign:'center'}}>Just fill out the form below. You can also attach a file.</h3>
              <br />
              <FormMsg/>


              <br /><br />
              <h3 style={{fontSize:'1em'}}>Do you want to receive a quote?<br />Fill out a brief.</h3>
              <br />
              <a className="btn" style={{fontSize:'1.1em'}}
              href="https://docs.google.com/forms/d/e/1FAIpQLSfZHfwPESZ4qMZljC9_L-WKIuQuAgLA-dadqM1CvjWkKix1cw/viewform"
              target="_blank" rel="noopener noreferrer">E-multicontent brief &nbsp; &nbsp;
              <img width="15px"  style={{verticalAlign:'middle', marginRight:'5px'}}   alt="brief - Copywriting agency Wrocław - translations and texts, SEO for websites, e-commerce and marketplace" src='/img/angle-right.svg'/></a>
              <br /><br />

              <h3 style={{fontSize:'1em'}}>Would you rather contact us via email?</h3>
              <br />
              <a className="btn" style={{fontSize:'1.1em'}}
              href="mailto:info@e-multicontent.com"
              target="_blank" rel="noopener noreferrer">Send an e-mail &nbsp; &nbsp;
              <img width="15px" height="22px"  style={{verticalAlign:'middle', marginRight:'5px'}}   alt="brief Agencja Copywriterska Wrocław - tłumaczenia i teksty, seo dla stron internetowych, e-commerce i na marketplace" src='/img/angle-right.svg'/></a>
              <br /><br />

              <h3 style={{fontSize:'1em'}}>Would you prefer to give us a call?</h3>
              <br />
              <a className="btn" style={{fontSize:'1.1em'}}
              href="tel:+48713074517"
              target="_blank" rel="noopener noreferrer">Call us &nbsp; &nbsp;
              <img width="15px" height="22px"   style={{verticalAlign:'middle', marginRight:'5px'}}   alt="brief Agencja Copywriterska Wrocław - tłumaczenia i teksty, seo dla stron internetowych, e-commerce i na marketplace" src='/img/angle-right.svg'/></a>
              <br /><br />

              <h3 style={{fontSize:'1em'}}>Pay us a visit at your convenience:</h3>
              <br />
              <a className="btn" style={{fontSize:'1.1em'}} href="https://www.google.com/maps/place/e-multicontent+-+wielojęzyczna+agencja+copywriterska/@51.1024556,17.0255398,17z/data=!3m1!4b1!4m5!3m4!1s0x470fc3f3c0f0f433:0xc6a93a9350239ead!8m2!3d51.1024565!4d17.0277043"
              target="_blank" rel="noopener noreferrer">Katarzyńska 1 F, 55-010 Radwanice&nbsp; &nbsp;
              <img width="15px" height="22px"   style={{verticalAlign:'middle', marginRight:'5px'}}   alt="brief - Agencja Copywriterska Wrocław - tłumaczenia i teksty, seo dla stron internetowych, e-commerce i na marketplace" src='/img/angle-right.svg'/></a>
              <br /><br />

              </div>

              </div>



              <br /><br />
              <div style={{textAlign:'center'}}>
              <b>The owner of the <Link className="dedlink" to="/">e<span style={{color:'#4a4a4a'}}>-multicontent</span></Link> brand is:</b><br />
              <a className="partners" target="_blank" rel="noopener noreferrer" href="https://iv-group.pl">
              <Img
              fluid={data.file2.childImageSharp.fluid}
              alt="Innovision Group"
              imgStyle={{objectFit:'contain'}}
              style={{
                padding: '0',
                width:'100%',minHeight:'50px',
                maxWidth:'200px',margin:'25px auto',
                objectFit:'contain',objectPosition:'center center'}}
                 />
               </a>
               <br />INNOVISION GROUP A. FILIP LIMITED PARTNERSHIP<br />
               <a className="dedlink" href="mailto:info@iv-group.pl" target="_blank" rel="noopener noreferrer">info@iv-group.pl</a>
               <br /><br />
               Pirenejska street  2/8<br />
               50-574 Wrocław<br /><br />
              <br />
              <br /><br />
              Tax Identification Number: 8971898232<br />
              National Business Registry Number: 520421727<br />
              National Court Register: 0000932139<br />
               </div>


              </div>
              </div>



          </div>

          <div style={{width:'100%',paddingLeft:'10%',paddingRight:'10%',backgroundColor:'rgb(245, 245, 245)',paddingBottom:'50px',textAlign:'center'}}>
            <Link className="btn" to="/"> Home </Link>&nbsp;&nbsp;&nbsp;
            <Link to="/about-us/" className="btn"> About us </Link> &nbsp;&nbsp;&nbsp;
            <Link to="/offer/" className="btn">Offer</Link>&nbsp;&nbsp;&nbsp;
            <Link className="btn" to="/blog/"> Blog </Link>&nbsp;&nbsp;&nbsp;
            <Link to="/portfolio/" className="btn"> Portfolio </Link> &nbsp;&nbsp;&nbsp;
            <Link to="/career/" className="btn"> Career </Link> &nbsp;&nbsp;&nbsp;
            <a className="btn" href="#newsletter"> Newsletter </a>&nbsp;&nbsp;&nbsp;
            <Link className="btn" to="/ebook/"> E-book </Link>&nbsp;&nbsp;&nbsp;
          </div>

          <div className="lazy-load" id="mapp">
        {/*<MapContainer />*/}
        <iframe title="google map"
src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d10026.38890761939!2d17.0209058!3d51.0789848!3
m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x470fc3f3c0f0f433%3A0xc6a93a9350239ead!2semulticontent!5e0!3m2!1spl!2spl!4v1694689330347!5m2!1spl!2spl" width="100%" height="550" style={{border:'0',marginBottom:'-10px'}}
allowFullScreen="" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
          </div>

        {/*  <div
            className="full-width-image-container eight lazy-background"
            style={{
              backgroundColor: '#36b3d2',
              backgroundPosition: `bottom left`,
              backgroundSize:'cover',
              backgroundRepeat:'no-repeat',
              height:'470px',
              marginBottom:'-50px',
              marginTop:'0px'
            }}
          ></div>*/}



      </Layout>
      </>
    )
  }

}



export const query = graphql`
  query Files{
    file1: file(relativePath: {regex: "/optimized/kontakt.jpg/"}) {
      childImageSharp {
        fluid(fit: CONTAIN) {
        srcWebp
        src
        srcSet
        srcSetWebp
      }
      }
    }
    file2: file(relativePath: {regex: "/optimized/logo_innovision.png/"}) {
      childImageSharp {
        fluid(fit: CONTAIN) {
        src
        srcSet
        originalImg
        srcSetWebp
      }
      }
    }
  }
`
